import { Component, inject, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Store } from '@ngxs/store';
import { MaintenanceMessageService } from '../services/maintenance-messages-service';
import { MaintenanceMessagesResponse } from '../models/maintenance-messages-response';
import { LoginPageOpened } from '../actions/auth-actions';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  imports: [AsyncPipe],
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  private readonly domSanitizer: DomSanitizer = inject(DomSanitizer);
  private readonly maintenanceMessageService: MaintenanceMessageService = inject(MaintenanceMessageService);
  private readonly store: Store = inject(Store);
  public readonly loginWebsite: SafeResourceUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
    `${environment.apiUrl}${environment.loginUrlSuffix}`
  );
  public readonly allowPrivateNetworkAccess = environment.allowPrivateNetworkAccess;

  public message$: Observable<MaintenanceMessagesResponse> = this.maintenanceMessageService.message$;

  public ngOnInit(): void {
    this.store.dispatch(new LoginPageOpened());
    this.maintenanceMessageService.loadData();
  }
}
